// @ts-nocheck
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ShieldOff } from 'lucide-react';

interface ModuleGuardProps {
  moduleId: string;
  children: React.ReactNode;
}

export function ModuleGuard({ moduleId, children }: ModuleGuardProps) {
  const { enabledModules, isSuperAdmin, currentSite } = useAuth();

  // Super admins bypass all module restrictions
  if (isSuperAdmin) return <>{children}</>;

  // No site selected
  if (!currentSite) return <Navigate to="/" replace />;

  // Check if module is enabled for current site
  if (!enabledModules.includes(moduleId)) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center max-w-sm mx-auto p-8">
          <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <ShieldOff size={32} className="text-red-400" />
          </div>
          <h2 className="text-lg font-bold text-gray-900 mb-2">دسترسی محدود</h2>
          <p className="text-sm text-gray-500 leading-relaxed">
            این ماژول برای سایت <strong>{currentSite.name}</strong> فعال نشده است.
            <br />
            برای فعال‌سازی با مدیر سیستم تماس بگیرید.
          </p>
          <button
            onClick={() => window.history.back()}
            className="mt-4 btn-secondary text-sm"
          >
            بازگشت
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
